module.exports = __webpack_public_path__ + "img/flowers.59e4de6e.jpg";